import ScrollOut from 'scroll-out';

const AnimateScroll = {
  init: () => {
    AnimateScroll.loadImages()
    AnimateScroll.toggleClasses()
    AnimateScroll.nav()
  },
  loadImages: () => {
    ScrollOut({
      once: true,
      onShown: (element) => {
        if (element.hasAttribute('data-load-bg')) {
          let img = element.getAttribute('data-load-bg');
          if (window.innerWidth < 769 && element.hasAttribute('data-load-bg-sm')) {
            img = element.getAttribute('data-load-bg-sm')
          }
          element.style.backgroundImage = `url('${img}')`
        }
        if (element.hasAttribute('data-src')) {
          if (window.innerWidth < 769 && element.hasAttribute('data-src-sm')) {
            element.src = element.getAttribute('data-src-sm')
          } else {
            element.src = element.getAttribute('data-src')
          }
        }
      },
    })
  },
  toggleClasses: () => {
    ScrollOut({
      once: true,
      targets: '[data-animate-class]',
      threshold: 0.2,
      onShown: (element) => {
        const classes = element.getAttribute('data-animate-class').split(' ')
        for (let i = 0; i < classes.length; i += 1) {
          element.classList.toggle(classes[i])
        }
      },
    })
  },
  nav: () => {
    const brand = document.getElementById('header-nav-brand')
    if (brand) {
      document.addEventListener('scroll', () => {
        if (window.scrollY > 100) {
          brand.classList.remove('md:w-40')
          brand.classList.add('md:w-32')
        } else {
          brand.classList.add('md:w-40')
          brand.classList.remove('md:w-32')
        }
      })
    }
  },
}
export default AnimateScroll
